<template>
    <v-container grid-list-xl fluid>
        <v-card class="mb-4">
            <v-layout row wrap pa-3>
                <v-flex lg3 md4 sm12>
                    <v-text-field label="Mã yêu cầu" :value="currentItem.RequestCode || 'Tự động'" readonly outlined dense></v-text-field>
                </v-flex>
                <v-flex lg3 md4 sm12>
                    <v-text-field label="Mã khách hàng" :value="currentItem.Username || currentUser.username" readonly outlined dense></v-text-field>
                </v-flex>
                <v-flex lg3 md4 sm12>
                    <v-text-field label="Tên khách hàng" :value="currentItem.CustomerName || ''" readonly outlined dense></v-text-field>
                </v-flex>
                <v-flex lg2 md4 sm12>
                    <v-chip dark :color="statusColor" class="mt-2">
                        {{ currentItem.Status | display_value(statusList) }}
                    </v-chip>
                </v-flex>
                <v-flex lg2 md4 sm12>
                    <v-text-field label="Tổng dòng" :value="details.length" readonly outlined dense></v-text-field>
                </v-flex>
                <v-flex lg2 md4 sm12>
                    <v-text-field label="Tổng kiện yêu cầu" :value="totalPack" readonly outlined dense></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-textarea
                        label="Ghi chú"
                        v-model="currentItem.Note"
                        :readonly="!canEditDraft"
                        rows="2"
                        outlined
                        dense
                    ></v-textarea>
                </v-flex>
                <v-flex lg3 md4 sm12 v-if="!roleCustomer">
                    <v-select
                        label="Trạng thái"
                        v-model="currentItem.Status"
                        :items="statusList"
                        item-text="name"
                        item-value="value"
                        outlined
                        dense
                    ></v-select>
                </v-flex>
                <v-flex lg3 md4 sm12 v-if="!roleCustomer">
                    <v-text-field
                        label="BillID liên kết"
                        v-model="currentItem.BillID"
                        type="number"
                        outlined
                        dense
                    ></v-text-field>
                </v-flex>
                <v-flex lg3 md4 sm12 v-if="currentItem.BillCode">
                    <v-text-field label="Phiếu xuất liên kết" :value="currentItem.BillCode" readonly outlined dense></v-text-field>
                </v-flex>
                <v-flex lg3 md4 sm12 v-if="!roleCustomer && currentItem.BillID">
                    <v-btn color="primary" class="mt-2" @click="openBill">
                        Mở phiếu xuất
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-card>

        <v-card>
            <v-layout row wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-layout row wrap justify-end>
                        <v-btn
                            color="primary"
                            small
                            class="mr-2"
                            @click="openInventoryDialog"
                            v-if="canEditDraft"
                        >
                            <v-icon left small>add</v-icon>
                            Thêm hàng tồn VN
                        </v-btn>
                        <v-btn
                            color="error"
                            small
                            @click="cancelRequest"
                            v-if="roleCustomer && isDraft && currentItem.ID > 0"
                        >
                            Hủy yêu cầu
                        </v-btn>
                    </v-layout>
                </v-flex>
                <v-flex lg12>
                    <v-data-table
                        :headers="detailHeaders"
                        :items="details"
                        disable-pagination
                        hide-default-footer
                    >
                        <template v-slot:item.GoodsType="{ item }">
                            {{ getGoodsTypeName(item.GoodsType) }}
                        </template>
                        <template v-slot:item.NumberOfPack="{ item }">
                            <v-text-field
                                v-if="canEditDraft"
                                v-model.number="item.NumberOfPack"
                                type="number"
                                min="1"
                                :max="item.AvailableNumberOfPack"
                                dense
                                hide-details
                                outlined
                            ></v-text-field>
                            <span v-else>{{ item.NumberOfPack | currency }}</span>
                        </template>
                        <template v-slot:item.actions="{ item, index }">
                            <div class="text-center">
                                <table-action-buttons :actions="getDetailActions(index)" :stacked="false"></table-action-buttons>
                            </div>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-card>

        <v-dialog v-model="dialogInventory" max-width="1200px">
            <v-card>
                <v-card-title class="headline">Chọn hàng tồn VN</v-card-title>
                <v-card-text>
                    <v-data-table
                        :headers="inventoryHeaders"
                        :items="inventoryItems"
                        item-key="ID"
                        show-select
                        v-model="selectedInventory"
                        :loading="loading"
                        disable-pagination
                        hide-default-footer
                        fixed-header
                        height="450px"
                    >
                        <template v-slot:item.GoodsType="{ item }">
                            {{ getGoodsTypeName(item.GoodsType) }}
                        </template>
                        <template v-slot:item.AvailableNumberOfPack="{ item }">
                            <span class="font-weight-bold">{{ item.AvailableNumberOfPack | currency }}</span>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogInventory = false">Đóng</v-btn>
                    <v-btn color="primary" @click="appendInventoryItems">Thêm vào yêu cầu</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapState } from 'vuex';
import configs from '@/configs';
import { sendErrorNotice } from '@/commons/utils';

export default {
    data() {
        return {
            statusList: configs.EXPORT_REQUEST_STATUS_LIST,
            dialogInventory: false,
            selectedInventory: [],
            details: [],
            currentItem: {
                ID: 0,
                UID: 0,
                RequestCode: '',
                CustomerName: '',
                Status: configs.EXPORT_REQUEST_STATUS.New,
                Note: '',
                BillID: null,
                BillCode: '',
            },
            detailHeaders: [
                { text: 'Mã vào kho', value: 'Code', sortable: false },
                { text: 'Mã vận đơn', value: 'SuffixBill', sortable: false },
                { text: 'Loại hàng', value: 'GoodsType', sortable: false },
                { text: 'Tên hàng', value: 'ProductNameCN', sortable: false },
                { text: 'Tồn khả dụng', value: 'AvailableNumberOfPack', align: 'end', sortable: false },
                { text: 'Số kiện yêu cầu', value: 'NumberOfPack', align: 'end', sortable: false },
                { text: 'Cân nặng', value: 'Weight', align: 'end', sortable: false },
                { text: 'Khối lượng', value: 'Volume', align: 'end', sortable: false },
                { text: 'Thao tác', value: 'actions', align: 'center', sortable: false, width: '80px' },
            ],
            inventoryHeaders: [
                { text: 'Mã vào kho', value: 'Code', sortable: false },
                { text: 'Mã vận đơn', value: 'SuffixBill', sortable: false },
                { text: 'Loại hàng', value: 'GoodsType', sortable: false },
                { text: 'Tên hàng', value: 'ProductNameCN', sortable: false },
                { text: 'Cân nặng', value: 'Weight', align: 'end', sortable: false },
                { text: 'Khối lượng', value: 'Volume', align: 'end', sortable: false },
                { text: 'Số kiện tồn', value: 'AvailableNumberOfPack', align: 'end', sortable: false },
            ],
        };
    },
    computed: {
        ...mapState({
            loading: state => state.exportRequest.loading,
            inventoryItems: state => state.exportRequest.availableProducts.data || [],
        }),
        currentUser() {
            return this.$store.state.authentication.user;
        },
        roleCustomer() {
            return this.currentUser.roleid == configs.ROLE_TYPE.Customer;
        },
        isDraft() {
            return Number(this.currentItem.Status || configs.EXPORT_REQUEST_STATUS.New) == configs.EXPORT_REQUEST_STATUS.New;
        },
        canEditDraft() {
            return this.roleCustomer && this.isDraft;
        },
        totalPack() {
            return this.details.reduce((sum, item) => sum + Number(item.NumberOfPack || 0), 0);
        },
        statusColor() {
            const status = this.statusList.find(item => item.value == this.currentItem.Status);
            return status ? status.color : 'grey';
        },
        requestId() {
            const pid = this.$route.params.Pid;
            return pid && pid !== 'new' ? Number(pid) : 0;
        }
    },
    methods: {
        getDetailActions(index) {
            return [
                { label: this.$t('actions.delete'), variant: 'danger-outline', hidden: !this.canEditDraft, onClick: () => this.removeDetail(index) }
            ];
        },
        buildRootOptions() {
            this.$root.$emit('REQUEST_ROOT_OPTION', {
                invisibleCreateButton: true,
                invisibleSaveButton: this.roleCustomer ? !this.isDraft : false,
            });
        },
        async loadDetail() {
            if (!this.requestId) {
                this.currentItem = {
                    ID: 0,
                    UID: this.currentUser.userid,
                    RequestCode: '',
                    Username: this.currentUser.username,
                    CustomerName: this.currentUser.fullname || '',
                    Status: configs.EXPORT_REQUEST_STATUS.New,
                    Note: '',
                    BillID: null,
                    BillCode: '',
                };
                this.details = [];
                this.buildRootOptions();
                return;
            }
            const item = await this.$store.dispatch('exportRequest/getDetail', this.requestId);
            this.currentItem = { ...item };
            this.details = (item.Details || []).map(detail => ({
                ...detail,
                NumberOfPack: Number(detail.NumberOfPack || 0),
            }));
            this.buildRootOptions();
        },
        getGoodsTypeName(goodsType) {
            return Number(goodsType || 0) === 1 ? 'TN' : 'CN';
        },
        async saveItem() {
            if (this.details.length === 0) {
                sendErrorNotice('Yêu cầu xuất kho phải có ít nhất 1 dòng hàng.');
                return;
            }
            for (const detail of this.details) {
                const numberOfPack = Number(detail.NumberOfPack || 0);
                const available = Number(detail.AvailableNumberOfPack || 0);
                if (numberOfPack <= 0) {
                    sendErrorNotice('Số kiện yêu cầu phải lớn hơn 0.');
                    return;
                }
                if (numberOfPack > available) {
                    sendErrorNotice(`Số kiện yêu cầu của mã hàng ${detail.Code} vượt quá tồn khả dụng.`);
                    return;
                }
            }

            const payload = {
                UID: this.currentItem.UID || this.currentUser.userid,
                Note: this.currentItem.Note,
                Status: this.currentItem.Status,
                BillID: this.currentItem.BillID,
                Details: this.details.map(item => ({
                    ProductID: item.ProductID || item.ID,
                    NumberOfPack: Number(item.NumberOfPack || 0),
                }))
            };

            const response = await this.$store.dispatch('exportRequest/setDetail', {
                data: payload,
                id: this.requestId,
                notify: this.requestId ? 'Cập nhật yêu cầu xuất kho thành công.' : 'Tạo yêu cầu xuất kho thành công.',
            });
            const savedItem = response && response.data ? response.data : response;
            if (savedItem && savedItem.ID) {
                const id = savedItem.ID;
                if (!this.requestId) {
                    this.$router.replace({ name: 'ExportRequestDetail', params: { Pid: id } });
                }
                await this.loadDetail();
            } else {
                await this.loadDetail();
            }
        },
        async openInventoryDialog() {
            this.selectedInventory = [];
            const params = {
                pagination: {
                    page: 1,
                    itemsPerPage: 1000,
                    sortBy: ['ID'],
                    sortDesc: [true]
                }
            };
            if (!this.roleCustomer && this.currentItem.UID) {
                params.UID = this.currentItem.UID;
            }
            await this.$store.dispatch('exportRequest/getAvailableProducts', params);
            this.dialogInventory = true;
        },
        appendInventoryItems() {
            this.selectedInventory.forEach(item => {
                const existed = this.details.find(detail => Number(detail.ProductID || detail.ID) == Number(item.ID));
                if (!existed) {
                    this.details.push({
                        ...item,
                        ProductID: item.ID,
                        NumberOfPack: Number(item.AvailableNumberOfPack || 0),
                    });
                }
            });
            this.dialogInventory = false;
        },
        removeDetail(index) {
            this.details.splice(index, 1);
        },
        async cancelRequest() {
            if (!this.requestId) {
                this.$router.push({ name: 'ExportRequestList' });
                return;
            }
            await this.$store.dispatch('exportRequest/removeDetail', this.requestId);
            await this.loadDetail();
        },
        openBill() {
            if (!this.currentItem.BillID) {
                return;
            }
            this.$router.push({
                name: 'BillDetail',
                params: {
                    Pid: this.currentItem.BillID
                }
            });
        }
    },
    mounted() {
        this.$root.$on('PRE_SAVE_DATA', this.saveItem);
        this.$root.$on('REQUEST_SAVE_DATA', this.saveItem);
        this.$root.$on('REQUEST_REFRESH_DATA', this.loadDetail);
        this.loadDetail();
    },
    beforeDestroy() {
        this.$root.$off('PRE_SAVE_DATA');
        this.$root.$off('REQUEST_SAVE_DATA');
        this.$root.$off('REQUEST_REFRESH_DATA');
    }
};
</script>
